import { Component, Input, OnDestroy, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { BehaviorSubject } from 'rxjs';
import { OverlayService } from '../../services/overlay.service';

/**
 * Local replacement for @reflact/ngx-layout's OverlayAsideComponent, built on PrimeNG's Drawer.
 * Keeps the same public API (setSelected/unsetSelected/openModal/closeModal/selectedObject/opened$)
 * so consuming components don't need to change their logic, only the import path.
 */
@Component({
  selector: 'app-overlay-aside',
  standalone: true,
  imports: [CommonModule, DrawerModule],
  templateUrl: './overlay-aside.component.html'
})
export class OverlayAsideComponent implements OnDestroy {
  @Input() public skipQueryParam = false;

  public selectedObject: any;
  public opened$ = new BehaviorSubject<boolean>(false);
  public overlayModalOpen = false;
  public overlayModalTemplate?: TemplateRef<HTMLElement>;

  private readonly keydownHandler = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') return;
    if (this.overlayModalOpen) {
      this.closeModal();
    } else if (this.selectedObject != undefined) {
      this.unsetSelected();
    }
  };

  constructor(private overlayService: OverlayService) {
    document.addEventListener('keydown', this.keydownHandler);
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  public setSelected(obj: any, uniqueIdentifier: string = '_id'): void {
    this.closeModal();
    this.selectedObject = obj;
    this.opened$.next(true);
    if (!this.skipQueryParam) {
      this.overlayService.set('selected', obj[uniqueIdentifier].toString());
    }
  }

  public unsetSelected(): void {
    this.closeModal();
    this.selectedObject = undefined;
    this.opened$.next(false);
    if (!this.skipQueryParam) {
      this.overlayService.set('selected', undefined);
    }
  }

  public openModal(template: TemplateRef<HTMLElement>): void {
    this.overlayModalTemplate = template;
    this.overlayModalOpen = true;
  }

  public closeModal(): void {
    this.overlayModalTemplate = undefined;
    this.overlayModalOpen = false;
  }
}
